export default __webpack_public_path__ + "static/media/pikachu-searchingjpg.153f950d.jpg";